import Service from '@ember/service';
import moment from 'moment-timezone';
import { computed } from '@ember/object';

type Details = {
  image?: string;
  message?: string;
  extras?: any;
};

type PageDetails = {
  pageName: string;
  details: Details;
};

type SpecialDay = {
  title: string;
  date: string;
  pages: PageDetails[];
};

export const SPECIAL_DAYS: Readonly<SpecialDay[]> = [
  {
    title: "Valentine's Day",
    date: '14-02',
    pages: [
      {
        pageName: 'Login',
        details: {
          image: new URL('cio/assets/images/valentines-animation.svg', import.meta.url).toString(),
        },
      },
    ],
  },
  {
    title: 'Halloween Day',
    date: '31-10',
    pages: [
      {
        pageName: 'Login',
        details: {
          image: new URL('cio/assets/images/skull_quill_animation.svg', import.meta.url).toString(),
          // eslint-disable-next-line spellcheck/spell-checker
          message: 'Veelcome back!',
        },
      },
    ],
  },
];

export default class CelebrationsService extends Service {
  today = moment();

  get loginCelebration() {
    if (this.specialDay) {
      return this.specialDay.pages.find(({ pageName }) => pageName === 'Login');
    }
    return;
  }

  @computed('today')
  get specialDay() {
    return SPECIAL_DAYS.find(({ date }) => moment(date, 'DD-MM').isSame(moment(), 'date'));
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    celebrations: CelebrationsService;
  }
}
